export default "__VITE_ASSET__9e4e5f27__"